import React, { useState, useEffect } from "react";
import classes from "./AllHistory.module.css";
import {
  Row,
  Col,
  Form,
  Card,
  Button,
  Table,
  Tabs,
  Tab,
} from "react-bootstrap";

const AllHistory = (props) => {
  const [AllRecords, setAllRecords] = useState([]);
  const [Itemname, setItemname] = useState(props.Itemname);
  const [HistoryDate, setHistoryDate] = useState("");

  const sortFunction = (a, b) => {
    if (a["TrackingNo"] === b["TrackingNo"]) {
      return 0;
    } else {
      return a["TrackingNo"] < b["TrackingNo"] ? -1 : 1;
    }
  };

  const getActualValue = () => {};

  useEffect(() => {
    let Records = props.Records;
    Records.sort(sortFunction);
    setAllRecords(Records);
    let ThisDate = props.myDates.dates;
    if (props.myDates.type == "specific") {
      setHistoryDate(
        ("ALL HISTORY RECORDS OF " + Itemname + " ON " + ThisDate).toUpperCase()
      );
    } else {
      setHistoryDate(
        (
          "ALL HISTORY RECORDS OF " +
          Itemname +
          " FROM " +
          ThisDate[0] +
          " TO " +
          ThisDate[ThisDate.length - 1]
        ).toUpperCase()
      );
    }
  }, []);

  return (
    <Row>
      <Col md={12} sm={12} xs={12}>
        <Row>
          <Col md={12} sm={12} xs={12}>
            <Card>
              <Card.Header>{HistoryDate}</Card.Header>
              <Card.Body>
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <td className={classes.tablecss}>SN</td>
                      <td className={classes.tablecss}>DATE_OF_TRANSACTION</td>
                      <td className={classes.tablecss}>DESCRIPTION</td>
                      <td className={classes.tablecss}>OPENING QUANTITY</td>
                      <td className={classes.tablecss}>BULK SOLD/SUPPLIED</td>
                      <td className={classes.tablecss}>UNIT SOLD/SUPPLIED</td>
                      <td className={classes.tablecss}>CLOSING QUANTITY</td>
                      <td className={classes.tablecss}>STAFF</td>
                    </tr>
                  </thead>
                  <tbody>
                    {AllRecords.map((SR, index) => (
                      <tr
                        key={index}
                        className={
                          SR.TType === "Sales"
                            ? classes.tablerowcss1
                            : SR.TType === "Supply"
                            ? classes.tablerowcss2
                            : classes.tablerowcss3
                        }
                      >
                        <td className={classes.tablecss}>{index + 1}</td>
                        <td className={classes.tablecss}>
                          {SR.TransactionDate}
                        </td>
                        <td className={classes.tablecss}>
                          {SR.TType === "Price"
                            ? SR.Person
                            : SR.Person === "Not Supplied"
                            ? "Quantity Edited from the Inventory"
                            : SR.TType +
                              (SR.TType === "Sales" ? " to " : " from ") +
                              SR.Person}
                        </td>
                        <td className={classes.opentablecss}>
                          <a
                            title={SR.ToolTipBefore}
                            href="#"
                            onClick={getActualValue}
                            className={classes.alinks}
                          >
                            {SR.BBBefore}
                          </a>
                        </td>
                        <td className={classes.tablecss}>{SR.Bulk}</td>
                        <td className={classes.tablecss}>{SR.Unit}</td>
                        <td className={classes.closetablecss}>
                          <a
                            title={SR.ToolTipAfter}
                            href="#"
                            onClick={getActualValue}
                            className={classes.alinks}
                          >
                            {SR.BBAfter}
                          </a>
                        </td>
                        <td className={classes.tablecss}>{SR.Staff}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AllHistory;
